module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top-bar com-model m-b-15"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/index/home'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("公告通知")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "com-model"
  }, [(_vm.total) ? [_c('div', _vm._l((_vm.list), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "notice-item"
    }, [_c('div', {
      staticClass: "notice-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "notice-content"
    }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), _c('div', {
      staticClass: "flex flex-between"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "pub-name"
    }, [_vm._v(_vm._s(item.publishUsername))]), _vm._v(" "), _c('div', {
      staticClass: "pub-time"
    }, [_vm._v(_vm._s(item.createdAt))])]), _vm._v(" "), _c('div', {
      staticClass: "primary-btn",
      on: {
        "click": function($event) {
          _vm.handleDetail(item)
        }
      }
    }, [_vm._v("查看详情")])])])
  })), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total),
      expression: "total"
    }],
    staticStyle: {
      "margin-top": "40px",
      "padding-bottom": "40px"
    },
    attrs: {
      "current-page": _vm.pageNum,
      "page-sizes": [5, 10, 20, 30, 40],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })] : _c('no-data')], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5e2d3ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/notice/list.vue
// module id = 910
// module chunks = 1